import type { useFenster } from './fenster';

// Die Anfasser zum Größenändern — rechte Kante, untere Kante, Ecke.
//
// Eigene statt des nativen CSS-Griffs (`resize: both`): der ist ein etwa 15 Pixel grosses Dreieck
// in der äussersten Ecke und auf dunklem Grund praktisch unsichtbar. Man muss wissen, dass es ihn
// gibt, und ihn dann auch treffen. Diese hier sind breiter (Kanten 8 px, Ecke 20 px), zeigen den
// passenden Mauszeiger und die Ecke trägt zwei sichtbare Striche — der Unterschied zwischen „geht
// nicht" und „hab ich nicht gefunden" ist von innen nicht zu erkennen, von aussen aber derselbe.
//
// Gehört zum Fenster-Rahmen, nicht zum Inhalt: `absolute` innerhalb der (fixierten) Fensterwurzel.
export function FensterGriffe({ griffe }: { griffe: ReturnType<typeof useFenster>['griffe'] }) {
  return (
    <>
      {/* Kanten bewusst schmal (6 px): sie liegen über der äussersten Randspalte des Fensters, und
          dort verläuft bei rollbaren Inhalten die Bildlaufleiste. Wer sie breiter macht, macht das
          Rollen mit der Maus unmöglich — deshalb ist die ECKE der grosse, sichtbare Anfasser und
          die Kanten sind die Feinjustierung für die, die sie suchen. */}
      <div {...griffe.rechts} title="Breite ändern"
           className="absolute top-0 right-0 h-full w-1.5 cursor-ew-resize touch-none" />
      <div {...griffe.unten} title="Höhe ändern"
           className="absolute bottom-0 left-0 w-full h-1.5 cursor-ns-resize touch-none" />
      <div {...griffe.ecke} title="Größe ändern"
           className="absolute bottom-0 right-0 h-5 w-5 cursor-nwse-resize touch-none group">
        {/* Zwei Striche im 45°-Winkel — dieselbe Sprache wie der Griff, den jedes Fenster-System
            unten rechts trägt. Sichtbar, aber leise; unter dem Zeiger wird er deutlicher. */}
        <svg viewBox="0 0 20 20" aria-hidden
             className="absolute inset-0 h-full w-full text-text-muted/50 group-hover:text-accent">
          <path d="M18 8 L8 18 M18 13 L13 18" stroke="currentColor" strokeWidth="1.5"
                strokeLinecap="round" fill="none" />
        </svg>
      </div>
    </>
  );
}
